<template>
	<div>
		<div v-if="loading" class="fill-row">
			<div id="div-with-loading" class="vs-con-loading__container text-center">Bestellingen ophalen...</div>
		</div>

		<div v-else>

			<vs-alert active="true" class="mb-2 break-words pt-2 pb-2 h-auto d-block sm:hidden">
				Deze pagina is nog niet geoptimaliseerd voor gebruik op je mobiele telefoon.
			</vs-alert>

			<filtermodules ref="filtermodules" @filter-change="onFilterChange" />

			<div class="vx-row">
				<div class="vx-col w-full md:w-1/2 xl:w-1/2">
					<cardamount :order-amount="this.$store.state.openOrdersStore.openOrders.amount" />
				</div>

				<div class="vx-col w-full md:w-1/2 xl:w-1/2">
					<cardvalue :order-value="this.$store.state.openOrdersStore.openOrders.totalValue.toFixed(2)" />
				</div>
			</div>

			<div class="vx-row justify-between items-center" v-if="this.ordersAmount > 0">
				<div class="vx-col pt-2 pb-2">
					<div class="flex items-center gap-2">
						<div class="mr-2">
							<selectall ref="selectall" />
						</div>
						<div class="mr-2">
							<selectedamount />
						</div>
						<processvvbbutton ref="processvvbbutton" />
					</div>
				</div>
				<div class="vx-col pt-2 pb-2">
					<div class="flex flex-wrap">
						<div class="mr-2 mb-2 lg:mb-0">
							<printaddressselected :dymo-printer="dymoPrinter" />
						</div>
						<div class="mr-2 mb-2 lg:mb-0">
							<printreturnselected :dymo-printer="dymoPrinter" />
						</div>
						<div class="mr-2 mb-2 lg:mb-0">
							<downloadpackingslib />
						</div>
						<div class="mr-2 mb-2 lg:mb-0">
							<shiporders />
						</div>
						<div class="mr-2 mb-2 lg:mb-0">
							<downloadlabelpdfs />
						</div>
					</div>
				</div>

				<div class="vx-col-2 pt-2 pb-2">
					<div class="flex flex-wrap">
						<div class="mr-2 mb-2 lg:mb-0">
							<selectSort ref="selectSort" />
						</div>
						<div class="mr-2">
							<search ref="search" />
						</div>
						<div class="mr-2 mb-2 mt-3">
							<vx-tooltip class="flex" position="left" text="Hoe en wat?">
								<font-awesome-icon icon="question-circle" @click="wiki()"></font-awesome-icon>
							</vx-tooltip>
						</div>
					</div>
				</div>
			</div>

			<div class="vx-row" v-if="this.ordersAmount > 0">

				<div class="vx-col w-full mb-base">
					<div class="vx-row" v-if="isSearch()">
						<order :order="order" :dymo-printer="dymoPrinter" :key="order.order.id" v-for="(order) in filterOrdersByModules(this.$refs.search.orders)" />
					</div>

					<div class="vx-row" v-else>
						<order :order="order" :dymo-printer="dymoPrinter" :key="order.order.id" v-for="(order) in filteredOrders" />
					</div>
				</div>
				<div class="vx-col w-full mb-base">
					<div class="text-center" v-if="isSearchLoading()">
						<font-awesome-icon :icon="['fas', 'cog']" class="fa-icon fa-spin fa-2x" />
						<font-awesome-icon :icon="['fas', 'search']" class="fa-icon" />
						Zoeken naar '{{ this.$refs.search.getSearchText() }}'...
					</div>
					<div v-else>
						<new-orders :orders-new-amount="this.ordersNewAmount" />

						<div v-if="isSearch()">
							<scroll-loader :loader-method="this.$refs.search.loadMoreOrders"
										   :loader-disable="this.$refs.search.loadMoreAvailable()" />

							<div class="text-center text-muted text-sm"
								 v-if="this.$refs.search.loadMoreAvailable() && !this.$refs.search.isSearchEmpty()">
								Dit zijn alle gevonden bestellingen
							</div>

							<div class="text-center text-muted text-sm" v-if="this.$refs.search.isSearchEmpty()">
								Geen resultaten gevonden voor "{{ this.$refs.search.getSearchText() }}".
							</div>
						</div>

						<div v-else>
							<scroll-loader :loader-method="loadMoreOrders" :loader-disable="!loadMoreAvailable()" />

							<div class="text-center text-muted text-sm" v-if="!loadMoreAvailable() && this.ordersNewAmount === 0">
								Dit zijn alle openstaande bestellingen
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="vx-row" v-else>
				<div class="vx-col w-full mb-base text-center">
					<font-awesome-icon :icon="['fas', 'check-double']" class="fa-icon fa-orders-done" />
					<h1 class="orders-done">Je hebt geen openstaande bestellingen</h1>
				</div>
			</div>
		</div>
		<vvbprocessmodal ref="vvbprocessmodal" @orders-processed="onVvbOrdersProcessed" />
	</div>
</template>

<script>
import Vue from 'vue';
import order from './order/order'
import cardamount from './cardamount';
import cardvalue from './cardvalue';
import search from './search';
import selectall from './selectall';
import printaddressselected from './printshippingselected';
import dymoPrinter from '../../services/dymo/dymoPrinter';
import Printreturnselected from './printreturnselected';
import downloadpackingslib from './downloadpackingslib';
import Selectedamount from './selectedamount';
import Shiporders from './shiporders';
import ScrollLoader from 'vue-scroll-loader'
import NewOrders from './newOrders';
import selectSort from './selectSort';
import Downloadlabelpdfs from "./downloadlabelpdfs.vue";
import filtermodules from './filtermodules';
import processvvbbutton from './processvvbbutton';
import vvbprocessmodal from './vvbprocessmodal';

Vue.use(ScrollLoader);

export default {
	name: 'orders',
	data() {
		return {
			loading: true,
			orderSort: 'dateOldNew',
			selectedOrderIds: [],
			ordersAmountLastLoad: 0,
			page: 1,
			maxPage: 1,
			pageSize: 20,
			nextPageLoading: false,
			dymoPrinter: new dymoPrinter(),
			selectedFilters: ['all']
		}
	},
	components: {
		vvbprocessmodal,
		processvvbbutton,
		filtermodules,
		Downloadlabelpdfs,
		NewOrders,
		Shiporders,
		Selectedamount,
		downloadpackingslib,
		Printreturnselected,
		printaddressselected,
		cardvalue,
		cardamount,
		search,
		selectall,
		order,
		selectSort
	},
	computed: {
		orders() {
			return this.$store.state.openOrdersStore.openOrders.orders;
		},
		ordersAmount() {
			return this.$store.state.openOrdersStore.openOrders.amount;
		},
		ordersNewAmount() {
			return this.$store.state.openOrdersStore.openOrders.newAmount;
		},
		filteredOrders() {
			return this.orders;
		}
	},
	watch: {
		'selectedOrderIds'() {
			this.checkAllSelected();
		},
		'orders'() {
			this.selectedOrderIds = this.selectedOrderIds.filter(orderId => {
				const foundIndex = this.orders.findIndex(order => {
					return order.order.id === orderId;
				});

				return foundIndex > -1;
			});
		},
		'ordersAmount'() {
			this.maxPage = Math.ceil((this.ordersAmount / this.pageSize));
			if (this.$refs.search) {
				if (!this.$refs.search.isSearchState()) {
					if (this.ordersAmount < this.ordersAmountLastLoad) {
						this.page = Math.floor(this.orders.length / this.pageSize);
					}
				}
			}
		}
	},
	mounted() {
		this.$vs.loading();

		this.dymoPrinter.init();

		this.nextPageLoading = true;
		this.$store.dispatch('openOrdersStore/init').then(res => {
			this.$store.dispatch('openOrdersStore/loadMetadata');
			const filterParams = this.getApiFilters();
			this.$store.dispatch('openOrdersStore/loadMore', {
				pageSize: this.pageSize,
				page: this.page,
				sort: this.orderSort,
				filters: filterParams.filters,
				type: filterParams.type
			}).then(res => {
				this.maxPage = Math.ceil((this.ordersAmount / this.pageSize));
				this.ordersAmountLastLoad = this.ordersAmount;
				this.nextPageLoading = false;

				this.$store.dispatch('sendOptions/init').then(response => {
					this.loading = false;

					this.$vs.loading.close();
				});
			}).catch(error => {
				console.log(error);
				this.$vs.loading.close();

				this.$vs.notify({
					title: 'Oops!',
					text: 'Het is niet gelukt je bestellingen op te halen',
					color: 'danger'
				});
			});
		}).catch(error => {
			console.log(error);
			this.$vs.loading.close();

			this.$vs.notify({
				title: 'Oops!',
				text: 'Het is niet gelukt je bestellingen op te halen',
				color: 'danger'
			});
		});
	},
	methods: {
		filterOrdersByModules(ordersToFilter) {
			if (!ordersToFilter || ordersToFilter.length === 0) {
				return ordersToFilter;
			}

			if (this.selectedFilters.includes('all')) {
				return ordersToFilter;
			}

			return ordersToFilter.filter(order => {
				if (this.selectedFilters.includes('bol') && order.order.type === 1) {
					return true;
				}
				if (this.selectedFilters.includes('lightspeed') && order.order.type === 2) {
					return true;
				}
				if (this.selectedFilters.includes('bol-vvv') && order.order.type === 1 && !order.order.is_bol_vvb_order) {
					return true;
				}
				if (this.selectedFilters.includes('bol-vvb') && order.order.type === 1 && order.order.is_bol_vvb_order) {
					return true;
				}
				return false;
			});
		},
		onFilterChange(filters) {
			this.selectedFilters = filters;
			this.selectedOrderIds = [];
			if (this.$refs.selectall) {
				this.$refs.selectall.checkAllSelected();
			}

			this.page = 1;
			this.$store.commit('openOrdersStore/SET_OPEN_ORDER_ORDERS', []);
			this.loadMoreOrders();
		},
		sortChange(orderSort) {
			this.orderSort = orderSort;

			this.page = 0;
			this.loadMoreOrders();
		},
		isSearch() {
			return this.$refs.search && this.$refs.search.isSearchState();
		},
		isSearchLoading() {
			return this.$refs.search && this.$refs.search.isSearchLoading();
		},
		loadMoreAvailable() {
			return this.page < this.maxPage;
		},
		loadMoreOrders() {
			this.page++;

			this.nextPageLoading = true;

			const filterParams = this.getApiFilters();
			const payload = {
				pageSize: this.pageSize,
				page: this.page,
				sort: this.orderSort,
				filters: filterParams.filters,
				type: filterParams.type
			};

			this.$store.dispatch('openOrdersStore/loadMore', payload).then(res => {
				this.maxPage = Math.ceil((this.ordersAmount / this.pageSize));
				this.ordersAmountLastLoad = this.ordersAmount;
				this.nextPageLoading = false;
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het is niet gelukt om meer bestellingen op te halen',
					color: 'danger'
				});
			});
		},
		getApiFilters() {
			const filterParams = {
				filters: ['open'],
				type: null
			};

			if (this.selectedFilters.includes('bol')) {
				filterParams.type = 1;
			} else if (this.selectedFilters.includes('lightspeed')) {
				filterParams.type = 2;
			}

			if (this.selectedFilters.includes('bol-vvb')) {
				filterParams.filters.push('vvb');
			}
			if (this.selectedFilters.includes('bol-vvv')) {
				filterParams.filters.push('vvv');
			}

			return filterParams;
		},
		checkAllSelected() {
			if (this.$refs.selectall) {
				this.$refs.selectall.checkAllSelected();
			}
		},
		getOrders() {
			if (this.isSearch()) {
				return this.filterOrdersByModules(this.$refs.search.orders);
			} else {
				return this.filteredOrders;
			}
		},
		getOrderCount() {
			return this.orders.length;
		},
		getSelectedOrders() {
			if (this.isSearch()) {
				return this.filterOrdersByModules(this.$refs.search.orders).filter(order => this.selectedOrderIds.includes(order.order.id));
			} else {
				return this.filteredOrders.filter(order => this.selectedOrderIds.includes(order.order.id));
			}
		},
		getSelectedOrdersCount() {
			return this.selectedOrderIds.length
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.orders)
		},
		onVvbOrdersProcessed(results) {
			const failedOrderIds = Object.entries(results)
				.filter(([_, result]) => !result.success)
				.map(([orderId, _]) => parseInt(orderId));

			if (failedOrderIds.length > 0) {
				this.selectedOrderIds = this.selectedOrderIds.filter(id => !failedOrderIds.includes(id));
				this.$refs.selectall.checkAllSelected();
			} else {
				this.selectedOrderIds = [];
				if (this.$refs.selectall) {
					this.$refs.selectall.checkAllSelected();
				}
			}

			this.loadMoreOrders();
		}
	}
}
</script>

<style>
.fa-orders-done {
	color: rgb(var(--vs-primary), 0.1);
	font-size: 20em;
	margin-top: 2vh;
	margin-bottom: 2vh;
}

h1.orders-done {
	color: rgb(var(--vs-primary), 0.1);
}
</style>
